module.exports = __webpack_public_path__ + "static/resume-16f5ae139e20c67d2b7f8ac8567bb281.pdf";